import httpManager from "@/app/shared/utils/httpManager";

export async function fetchWhatsappBalance(type = "whatsapp") {
  const url = `/billing/${type}/balance/`;
  const response = await httpManager.get(url);

  return response.data;
}
